import { render, staticRenderFns } from "./TokenFilters.vue?vue&type=template&id=6f41dd6e"
import script from "./TokenFilters.vue?vue&type=script&lang=js"
export * from "./TokenFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports